import React, { useEffect, useState,useContext } from "react";
import { List, Typography, Button, Empty } from 'antd';
import { of, from } from "rxjs";
import { debounceTime, switchMap, catchError } from "rxjs/operators";
import apiClientconops from "../../../ApiEndpoint/apiClientconops";
import apiUrlconops from "../../../ApiEndpoint/configconops";
import Spinner from "../../../components/Spinner/spinner";
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import { useAuthContext } from "../../../utils/AuthContext";

const ConopsNewsList = () => {
    const { user } = useAuthContext();
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { selectedState } = useContext(ConopsContext);

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        const params = {};

        if (selectedState) params.state = selectedState;
        //if (user?.email) params.user_email = user.email;


        const news$ = of(true).pipe(
            debounceTime(500), // wait before firing request
            switchMap(() =>
                from(
                    apiClientconops.get(`${apiUrlconops}/state_news`, { params,signal })
                ).pipe(
                    catchError((error) => {
                        console.error("Error fetching news:", error);
                        return of({ data: [] }); // return empty fallback
                    })
                )
            )
        );

        const subscription = news$.subscribe((response) => {
            setNewsData(response?.data || []);
            setLoading(false);
        });

        return () => {
            subscription.unsubscribe();
            controller.abort(); // cancel pending API if unmounted
        };
    }, [selectedState]);

    return (
        <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16 }}>
            <Typography.Title
                level={5}
                style={{ borderBottom: "2px solid #52c41a", paddingBottom: 8 }}
            >
                Relevant News
            </Typography.Title>

            <div style={{ maxHeight: "78vh", overflowY: "auto" }}>
                {loading ? (
                    <Spinner />
                ) : newsData.length > 0 ? (
                    <List
                        dataSource={newsData}
                        renderItem={(item, index) => (
                            <List.Item
                                key={index}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    padding: "12px 0",
                                    borderBottom: "1px solid #f0f0f0",
                                }}
                            >
                                <Typography.Text strong style={{ fontSize: 16 }}>
                                    {item.Title}
                                </Typography.Text>
                                <Typography.Text type="secondary" style={{ marginBottom: 8 }}>
                                    {new Date(item.date).toLocaleDateString()}
                                </Typography.Text>
                                <Button
                                    type="primary"
                                    href={item.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    size="small"
                                >
                                    Read More
                                </Button>
                            </List.Item>
                        )}
                    />
                ) : (
                    <Empty description="No data found" />
                )}
            </div>

        </div>
    );
};

export default ConopsNewsList;
